import { render, staticRenderFns } from "./ScrollableVueCard.vue?vue&type=template&id=02a5f7bf&scoped=true&"
import script from "./ScrollableVueCard.vue?vue&type=script&lang=js&"
export * from "./ScrollableVueCard.vue?vue&type=script&lang=js&"
import style0 from "./ScrollableVueCard.vue?vue&type=style&index=0&id=02a5f7bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a5f7bf",
  null
  
)

export default component.exports